import { render, staticRenderFns } from "./Point_Periodic.vue?vue&type=template&id=3152904d&scoped=true"
import script from "./Point_Periodic.vue?vue&type=script&lang=js"
export * from "./Point_Periodic.vue?vue&type=script&lang=js"
import style0 from "./Point_Periodic.vue?vue&type=style&index=0&id=3152904d&prod&lang=css"
import style1 from "./Point_Periodic.vue?vue&type=style&index=1&id=3152904d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3152904d",
  null
  
)

export default component.exports